"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Input_1 = require("./Input");
const TextInput = (_a) => {
    var { onChange, value } = _a, rest = __rest(_a, ["onChange", "value"]);
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, Object.assign({ onChange: onChange, type: "text", value: value }, rest)));
};
exports.TextInput = TextInput;
